import { render, staticRenderFns } from "./posterMaker.vue?vue&type=template&id=78b9206a&scoped=true&"
import script from "./posterMaker.vue?vue&type=script&lang=js&"
export * from "./posterMaker.vue?vue&type=script&lang=js&"
import style0 from "./posterMaker.vue?vue&type=style&index=0&id=78b9206a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b9206a",
  null
  
)

export default component.exports